import i18n from "../../../i18n";

const CompleteTaskController = async ({ res, req, flash, api, assert }) => {
  const { body } = req;

  assert(
    body.tasks && body.tasks.length,
    400,
    "At least one task must be selected"
  );

  try {
    await api(`complete-task`, { method: "PUT", body });
    flash("success", i18n.t("auth:user.updatedSuccess"));
  } catch (e) {
    console.log("error", e);
    flash("error", e.message);
  } finally {
    res.refreshWith({ tab: body.tab }, { url: "back" });
  }
};

export default CompleteTaskController;
